'use client';

import Icon, { Icons } from '@/components/elements/Icon';
import { AlertType } from './types';

interface AlertProps {
  children: React.ReactNode;
  alertType?: AlertType;
  className?: string;
  icon?: Icons;
}

const Alert = ({ children, icon, alertType, className }: AlertProps) => {
  const alertClass = getTypeClassname(alertType);

  return (
    <div
      className={`${
        className || ''
      } ${alertClass} font-medium text-sm py-3 px-4 rounded flex items-center`}
    >
      <Icon
        name={icon || Icons.EXCLAMATION_TRIANGLE}
        size={20}
        className="mr-2 flex-none"
      />
      <p>{children}</p>
    </div>
  );
};

const getTypeClassname = (type?: AlertType) => {
  switch (type) {
    case AlertType.SUCCESS:
      return 'bg-green-400';
    case AlertType.ERROR:
      return 'border-pink-500/30 bg-pink-500/10';
    case AlertType.WARNING:
      return 'bg-yellow-400 text-grey-50';
    case AlertType.INFO:
      return 'border border-blue-500/30 bg-blue-500/10 text-blue-500';
    default:
      return 'bg-yellow-400 text-grey-50';
  }
};

export default Alert;
